module.exports = __webpack_public_path__ + "static/img/new-user-guide.5a93918.png";


/*****************
 ** WEBPACK FOOTER
 ** ./static/images/new-user-guide.png
 ** module id = 342
 ** module chunks = 3
 **/